const profile = {
  visible: false,
  dapp: '',
  editable: false,
}

export default profile
